<template>
    <div class="bodyLogin">
        <vue-particles class="particles-js"
            color="#014aad"
            :particleOpacity="0.9"
            :particlesNumber="100"
            shapeType="circle"
            :particleSize="4"
            linesColor="#014aad"
            :linesWidth="2"
            :lineLinked="true"
            :lineOpacity="0.9"
            :linesDistance="150"
            :moveSpeed="6"
            :hoverEffect="true"
            hoverMode="grab"
            :clickEffect="true"
            clickMode="push"
        >
        </vue-particles>
        <div style="display: flex; flex-direction: column; align-items: center; max-width: 330px; z-index: 1;
        padding: 15px; width: 100%!important; background-color: #e3e1e1; border-radius: 2rem;">
            <img style="margin-bottom: 1rem!important; max-width: 100%;" :src="require('../assets/logo_isolutions.png')" alt="" width="700" height="150">
            <form @submit="login">
                <div style="width: 100%; padding-top: 2rem;">
                    <label><strong>Usuario</strong></label>
                    <vs-input 
                    style="text-align: start!important; margin-bottom: -1px; border-bottom-right-radius: 0; border-bottom-left-radius: 0;"
                    autocomplete="username"
                    type="email" v-model="form.email"/>
                </div>
                <div style="padding-top: 4rem; width: 100%;">
                    <label><strong>Contraseña </strong><svg v-if="hidePassword" xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 576 512" @click="hidePassword = !hidePassword"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"/></svg>
                        <svg v-else @click="hidePassword = !hidePassword" xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 640 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223.1 149.5C248.6 126.2 282.7 112 320 112c79.5 0 144 64.5 144 144c0 24.9-6.3 48.3-17.4 68.7L408 294.5c8.4-19.3 10.6-41.4 4.8-63.3c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3c0 10.2-2.4 19.8-6.6 28.3l-90.3-70.8zM373 389.9c-16.4 6.5-34.3 10.1-53 10.1c-79.5 0-144-64.5-144-144c0-6.9 .5-13.6 1.4-20.2L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5L373 389.9z"/></svg></label>
                    <vs-input
                    style="text-align: start!important; margin-top: 0px!important; margin-bottom: 20px; border-top-left-radius: 0; border-top-right-radius: 0;"
                    :type="passwordType"
                    autocomplete="current-password"
                    @keyup.enter="login"
                    v-model="form.password"/>
                </div>
                <div style="padding-top: 4rem; width: 100%; text-align-last: center;">
                    <vs-button :disabled="loading" style="background-color: #014aad!important; width: 100% !important;" color="primary" type="filled" @click="login();">
                        <span v-if="!loading">Ingresar</span>
                        <div v-else>
                            <div class="spinner-container">
                            <div class="custom-spinner"></div>
                            </div>
                        </div>
                    </vs-button>
                </div>
            </form>
            <p style="margin-top: 40px; color: #6c757d!important;">&copy; <span id="date">2018</span> Isolutions Technology.</p>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import { vsButton, vsInput } from 'vuesax'
import 'vuesax/dist/vuesax.css'
import jwtToken from "../helpers/jwt-token";
import VueParticles from 'vue-particles'
import getSecret from '../helpers/get-secret';
const serverUrl=getSecret('SERVER_URL');

Vue.use(VueParticles)
Vue.use(vsButton)
Vue.use(vsInput)

    export default {
        components: {
        },
        data: ()=>({
            form:{
                email:'',
                password:'',
            },
            loading:false,
            hidePassword: true,
            scr:'',
        }),
        computed: {
            passwordIcon() {
                return this.hidePassword ? 'fa-eye' : 'fa-eye-slash'
            },
            passwordType() {
                return this.hidePassword ? 'password' : 'text'
            },
            passwordType() {
                return this.hidePassword ? 'password' : 'text'
            },
        },
        methods:{
            login(){
                if(!this.loading){
                    this.loading=true
                    this.axios.post(serverUrl+'/api/login',this.form)
                    .then(res => {   
                        if(res.data.success == true){
                        jwtToken.setToken(res.data.token);
                        let tipo = {
                            "name": res.data.info.licencia.name,
                            "id_company": res.data.info.licencia.id_company,
                            "payment_data": res.data.info.licencia.payment_data,
                            "status_commercial": res.data.info.licencia.status_commercial,
                            "counter": res.data.info.licencia.counter,
                        }
                        let tipo1 = {
                            "email": res.data.info.usuario.email,
                            "rol": res.data.info.usuario.rol,
                            "name": res.data.info.usuario.name,
                            "id": res.data.info.usuario.id,
                        }
                        window.localStorage.setItem('jwt_user', JSON.stringify(tipo1));
                        window.localStorage.setItem('jwt_licencia', JSON.stringify(tipo));
                        if(res.data.info.licencia.status_commercial=='MORA'){
                            this.$vs.notify({
                                title:'Error',
                                text:'Tu ultimo pago no pudo ser procesado',
                                color:'danger'
                            })
                            this.loading=false
                        }else{
                            window.location.href = location.origin+'/admin/overview';
                        }
                        }else{
                            console.log(res.data);
                            window.alert("Credenciales invalidas");
                            this.loading=false
                        }
                    })
                    .catch(err => {
                        console.log(err.data);
                        window.alert("ERROR, intente nuevamente");
                        this.loading=false
                    });
                }
            }
        },
        mounted(){
            var dateElement = document.getElementById("date");
            var year = new Date().getFullYear();
            dateElement.textContent = year;
		}
    }
</script>
<style>
    .vuesax-app-is-ltr {
        background-color: #f5f5f5;
    }
    .particles-js {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
    .vs-input{
        width: 100%!important;

    }
    input{
        height: calc(3.5rem + 2px);
        border: none;
        font-size: 1rem;
    }
    body{
        background-color: #f1f5f7;
    }
    .bodyLogin {
        background-color: #000000;
        display: flex; 
        justify-content: center; 
        align-items: center; 
        padding: 40px; 
        height: 100vh;
    }
    .button-loading {
        cursor: not-allowed;
        opacity: 0.7;
        /* Estilos adicionales para el botón cuando está en estado de carga */
    }

.spinner-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.custom-spinner {
  /* Aquí puedes agregar estilos personalizados para tu spinner */
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top: 4px solid #014aad;
  width: 24px;
  height: 24px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>